
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migracja-numeru/sprawdz-mozliwosc",
      function () {
        return require("private-next-pages/migracja-numeru/sprawdz-mozliwosc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migracja-numeru/sprawdz-mozliwosc"])
      });
    }
  